import * as Effect from "effect/Effect";

import { ConnectionBlockedError } from "./model.ts";

export interface ServerVersionMismatch {
  readonly expectedVersion: string;
  readonly actualVersion: string;
}

/** Desktop uses an exact client/server release pair. Environment-served web
    clients omit expectedVersion because they already came from that server. */
export const requireCompatibleServerVersion = Effect.fn(
  "clientRuntime.connection.requireCompatibleServerVersion",
)(function* (input: {
  readonly expectedVersion?: string | undefined;
  readonly actualVersion: string;
}) {
  const expectedVersion = input.expectedVersion?.trim();
  if (!expectedVersion || input.actualVersion === expectedVersion) return;
  const mismatch: ServerVersionMismatch = {
    expectedVersion,
    actualVersion: input.actualVersion,
  };
  return yield* new ConnectionBlockedError({
    reason: "unsupported",
    detail: `This desktop is version ${expectedVersion}, while this environment is ${input.actualVersion}. Make both versions match, or open the environment's matching app.`,
    serverVersionMismatch: mismatch,
  });
});
